<template>
  <div>
    <!-- 历史曲线弹框 -->
    <!-- <el-dialog
    :append-to-body="true"
    :visible.sync="curve_show"
    title="历史曲线"
    width="80%"
    v-dialogDrag
    >

    </el-dialog> -->
    <!-- 曲线查询表单 -->
    <el-form
    :model="temp_form"
    class="temp_form"
    :inline="true"
    >
      <el-form-item label="时间范围:" prop="time_range">
        <el-date-picker
        v-model="temp_form.time_range"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        :picker-options="pickerOptions"
        @change="cold_data_change"
        ></el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="时间间隔:" prop="interval">
        <el-input type="number" v-model="temp_form.interval"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button
          :type="btn_type1"
          @click="temp_form.time_nodes=1,btn_type1='primary',btn_type2='',btn_type3=''">近1天</el-button>
          <el-button
          :type="btn_type2"
          @click="temp_form.time_nodes=7,btn_type1='',btn_type2='primary',btn_type3=''">近1周</el-button>
          <el-button
          :type="btn_type3"
          @click="temp_form.time_nodes=30,btn_type1='',btn_type2='',btn_type3='primary'">近1月</el-button>
        </el-button-group>
      </el-form-item> -->
      <el-form-item>
        <el-button
        type="primary"
        @click="get_data">查看温度数据</el-button>
        <el-button
        type="primary"
        v-if="btn_permission.includes('middle:warehousePoint:downloadPdf')||btn_permission.includes('superAdmin')"
        @click="export_data">导出温度数据</el-button>
        <el-button
        type="primary"
        v-if="btn_permission.includes('middle:warehousePoint:saveData')||btn_permission.includes('superAdmin')"
        @click="edit_data">库房管理</el-button>
        <el-button
        type="success"
        v-if="curve_detail_show==true"
        @click="get_curve_list">曲线明细</el-button>
      </el-form-item>
    </el-form>
    <!-- 曲线数据 -->
    <div ref="my_chart" id="export_chart">
      <canvas></canvas>
    </div>
    <!-- 曲线明细弹框 -->
    <el-dialog
    :append-to-body="true"
    :visible.sync="curve_show"
    :title="temperature_name+' 的曲线明细'"
    v-dialogDrag
    >
      <el-table
      :data="curve_detail_data"
      highlight-current-row
      border
      max-height="500"
      >
        <el-table-column
        align="center"
        prop="recordTime"
        label="时间"
        ></el-table-column>
        <el-table-column
        align="center"
        prop="temperature"
        :label="temperature_unit=='%'?'湿度(%)':'温度(°C)'"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  export default{
    data() {
      return{
        //路由传参
        router_params:{},
        // 历史曲线弹框
        curve_show:false,
        //权限数组
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        //历史曲线查询表单
        temp_form:{
          time_range:'',
          interval:'',
          time_nodes:1
        },
        //限定查询表单时间范围在32天以内
        truck_select_date:'',
        pickerOptions:{
          onPick:({maxDate,minDate})=>{
            this.truck_select_date=minDate.getTime()
            if(maxDate){
              this.truck_select_date=''
            }
          },
          disabledDate:(time)=>{
            if(this.truck_select_date!=''){
              const one=31*24*3600*1000
              const minTime=this.truck_select_date-one
              const maxTime=this.truck_select_date+one
              return time.getTime()<minTime||time.getTime()>maxTime
            }
          }
        },
        //按钮类型切换
        btn_type1:'primary',
        btn_type2:'',
        btn_type3:'',
        //echarts实例
        export_chart:'',
        //曲线明细按钮显影
        curve_detail_show:false,
        //曲线明细弹框显影
        curve_show:false,
        //曲线明细列表
        curve_detail_list:[],
        //曲线明细数据
        curve_detail_data:[],
        //温度数据名称
        temperature_name:'',
        //温度数据单位
        temperature_unit:''
      }
    },
    created() {
      //路由传参
      if(this.$route.query.row){
        this.router_params=this.$route.query.row
        this.$nextTick(()=>{
          this.temp_form.time_range=[this.router_params.warnTime+' 00:00:00',this.router_params.warnTime+' 23:59:59']
          //获取温度数据
          this.get_data()
        })
      }
    },
    mounted() {

    },
    beforeDestroy() {

    },
    watch:{
      '$route'(to,from){
        if(to.name=='cold_storage_data'&&this.$route.query.row){
          this.router_params=this.$route.query.row
          this.temp_form.time_range=[this.router_params.warnTime+' 00:00:00',this.router_params.warnTime+' 23:59:59']
          //获取温度数据
          this.get_data()
        }
      }
    },
    methods:{
      //时间范围change事件
      cold_data_change(value){

      },
      //获取温度数据
      get_data(){
        let that=this
        if(that.temp_form.time_range==null||that.temp_form.time_range==''||that.temp_form.time_range[0].indexOf('undefined')!=-1){
          that.$message.warning('请选择时间范围！')
          return false
        }
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehousePoint/pointData',
          params:{
            beginTime:that.temp_form.time_range[0],
            endTime:that.temp_form.time_range[1],
            pointIds:that.router_params.traceId=='N'?that.router_params.deviceId:that.router_params.traceId
          }
        }).then(data=>{
          if(data.data.success=true){
            if(data.data.data){
              if(data.data.data.length==1){
                this.temperature_name=data.data.data[0][0].deviceName
                this.temperature_unit=data.data.data[0][0].unit
                this.curve_detail_show=true
              }else{
                this.curve_detail_show=false
              }
              //渲染温度数据
              that.check_data(data.data.data)
            }else{
              //获取echarts实例
              that.export_chart=that.$echarts.init(document.getElementById('export_chart'))
              that.export_chart.clear()
            }
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //渲染温度数据
      check_data(data_list){
        //获取echarts实例
        document.getElementById('export_chart').removeAttribute('_echarts_instance_')
        this.export_chart=this.$echarts.init(document.getElementById('export_chart'))
        this.export_chart.clear()
        let that=this
        let series_old_list=[],series_new_list=[],
        yAxis_list=[],xAxis_list=[]
        let data_temp_list=data_list
        that.curve_detail_list=[]
        data_temp_list.forEach((item,index)=>{
          series_old_list.push([])
          that.curve_detail_list.push([])
          item.forEach((item1,index1)=>{
            item1.recordTime=that.publicAjax.genDateFromStamp(item1.recordTime)
            item1.temperature=parseFloat(item1.temperature).toFixed(1)
            series_old_list[index].push([item1.recordTime,item1.temperature])
            that.curve_detail_list[index].push({
              recordTime:item1.recordTime,
              temperature:item1.temperature
            })
          })
          xAxis_list.push({
            type:'category',
            axisLine: {
              onZero: false
            },
            showMaxLable:true,//显示最大值
            showMinLable:true,//显示最小值
            axisTick: {
              alignWithLabel: true
            }
          })
          yAxis_list.push({
            type:'value',
            axisLine:{onZero:false}
            // max:parseFloat(item[0].maxTemp)+2,//y轴最大值
            // min:parseFloat(item[0].minTemp)-2//y轴最小值
          })
          series_new_list.push({
            name:item[0].deviceName,
            id:'a'+index,
            type:'line',
            smooth:true,
            emphasis: {
              focus: 'series'
            },
            data:series_old_list[index]
          },{//温度下限(有效范围)
            id:'b'+index,
            type:'line',
            smooth:false,
            itemStyle: {
                normal: {
                    lineStyle: {
                        color:'green',
                        width: 2,
                        type: 'dotted'  //'dotted'虚线 'solid'实线
                    }
                }
            },
            data:[[series_old_list[index][0][0],parseFloat(item[0].minTemp)],[series_old_list[index][series_old_list[index].length-1][0],parseFloat(item[0].minTemp)]]
          },{//温度上限(有效范围)
            id:'c'+index,
            type:'line',
            smooth:false,
            itemStyle: {
                normal: {
                    lineStyle: {
                        color:'yellow',
                        width: 2,
                        type: 'dotted'  //'dotted'虚线 'solid'实线
                    }
                }
            },
            data:[[series_old_list[index][0][0],parseFloat(item[0].maxTemp)],[series_old_list[index][series_old_list[index].length-1][0],parseFloat(item[0].maxTemp)]]
          })
        })
        let option={
          legend: {},
          xAxis:xAxis_list,
          yAxis:yAxis_list,
          dataZoom:[
            // {
            //   type:'inside',
            //   throttle:50
            // }
            {
                id: 'dataZoomX',
                type: 'inside',
                xAxisIndex: [0],
                filterMode: 'filter'
            },
            {
                id: 'dataZoomY',
                type: 'inside',
                yAxisIndex: [0],
                filterMode: 'empty'
            },
            {
                id: 'dataZoomXs',
                type: 'slider'
                , show: true
                , xAxisIndex: [0]
                , filterMode: 'filter'
                , textStyle: {
                    color: "#409EFF"
                    , fontWeight: 'lighter'
                    , fontStyle: 'italic'
                    , width: 30
                    , fontSize: 9
                    , overflow: "break"
                }
            },
            {
                id: 'dataZoomYs',
                type: 'slider',
                yAxisIndex: [0],
                filterMode: 'empty'
                , textStyle: {
                    color: "#409EFF", width: '2', overflow: "truncate"
                }
            }
          ],
          series:series_new_list,
          tooltip:{
            trigger: 'axis',
            //表示不使用默认的【显示】【隐藏】触发规则
            axisPointer:{
              type:'cross',
              snap:true,
              label:{
                backgroundColor:'#6a7985',
                precision:1
              }
            },
            formatter:function(params){
              let res=params[0].data[0]+'<br>'
              for(var i=0;i<params.length;i++){
                if(params[i].seriesId.indexOf('a')!=-1){
                  res+= params[i].marker+params[i].seriesName+'<br>'+"温度："+parseFloat(params[i].data[1]).toFixed(1)+"°c<br>"
                }
              }
              return res
            }
          },
          toolbox:{
            show:true,
            feature:{
              saveAsImage: {
                  show: true,
                  excludeComponents: ['toolbox'],
                  pixelRatio: 2
              }
            }
          }
        }
        that.export_chart.setOption(option)
        that.export_chart.on('legendselectchanged',(params)=>{
          let selected_item=[]
          for(let key in params.selected){
            if(params.selected[key]==true){
              selected_item.push({
                label:key,
                value:params.selected[key]
              })
            }
          }
          if(selected_item.length==1){
            that.curve_detail_list=[]
            that.curve_detail_show=true
            data_temp_list.forEach(item=>{
              if(selected_item[0].label==item[0].deviceName){
                //温度数据名称
                that.temperature_name=item[0].deviceName
                //温度数据单位
                that.temperature_unit=item[0].unit
                item.forEach(item1=>{
                  that.curve_detail_list.push({
                    recordTime:item1.recordTime,
                    temperature:item1.temperature
                  })
                })
              }
            })
          }else{
            that.curve_detail_show=false
          }
        })
        window.addEventListener('resize',()=>{
          that.export_chart.resize()
        })
      },
      //将base64转换为file
      dataURLtoFile(dataurl,filename){
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bStr = atob(arr[1]), n = bStr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bStr.charCodeAt(n)
        }
        return new File([u8arr], filename, {type: mime})
      },
      //导出温度数据
      export_data(){
        if(this.temp_form.time_range==null){
          this.$message.warning('请选择时间范围后，再导出！')
          return false
        }
        //导出echarts实例
        this.export_chart=this.$echarts.init(document.getElementById('export_chart'))
        let picInfo=this.export_chart.getDataURL({
          type:'png',
          pixelRatio:1.5,
          backgroundColor:'#fff'
        })
        let img=this.dataURLtoFile(picInfo,'testImg.png')
        let formData=new FormData()
        formData.append('file',img)
        let that=this
        that.$axios({
          method:'post',
          url:that.publicAjax.extra_path+'/sccOwn/upload/image/coldTempChart',
          data:formData,
          headers:{
            "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
            "content-type":"multipart/form-data"
          }
        }).then(data=>{
          if(data.data.success==true){
            let url_list=data.data.data
            let imageUrl=url_list[0].url
            let imageMd5=url_list[0].md5
            //触发导出
            let url=that.publicAjax.extra_path+'/middle/warehousePoint/export/pdf/'+that.router_params.deviceId
            let gap=''
            let beginTime=that.temp_form.time_range[0]
            let endTime=that.temp_form.time_range[1]
            that.$axios({
              url:url,
              method:'get',
              responseType:'blob',
              params:{
                gap:gap,
                beginTime:beginTime,
                endTime:endTime,
                imageUrl:imageUrl,
                imageMd5:imageMd5
              }
            }).then(data=>{
              if(data.data.type=='text/plain'){
                that.pdfUrl=window.URL.createObjectURL(new Blob([data.data], {type:"application/pdf"}))
                let link=document.createElement('a')
                link.href=that.pdfUrl
                link.style.display='none'
                let fname=that.router_params.deviceName+'.pdf'
                link.setAttribute('download',fname)
                document.body.appendChild(link)
                link.click()
                URL.revokeObjectURL(link.href)
                document.body.removeChild(link)
              }else{
                const file=new FileReader()
                file.readAsText(data.data,'utf-8')
                file.onload=function(){
                  const obj=JSON.parse(file.result)
                  if(obj.success==false){
                    that.$message.warning(obj.message)
                  }
                }
              }
            })
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //修改温度数据
      edit_data(){
        if(this.temp_form.time_range==null||this.temp_form.time_range==''||this.temp_form.time_range[0].indexOf('undefined')!=-1){
          this.$message.warning('请选择时间范围！')
          return false
        }
        if(!this.router_params.deviceId){
          this.$message.warning('未找到设备ID')
          return false
        }
        let router_list=[]
        this.$store.state.openTab.forEach((item,index)=>{
          router_list.push(item.route)
        })
        if(router_list.includes('/cold/warehouse_manage')==false){
          this.$store.commit('add_tabs',{
            route:'/cold/warehouse_manage',
            name:'库房管理'
          })
        }
        this.$store.commit('set_active_index','/cold/warehouse_manage')
        this.$router.push({
          path:'/cold/warehouse_manage',
          query:{
            row:{
              time_range:this.temp_form.time_range,
              deviceId:this.router_params.deviceId
            }
          }
        })
      },
      //获取曲线明细列表
      get_curve_list(){
        this.curve_show=true
        if(this.curve_detail_list.length==1){
          this.curve_detail_data=this.curve_detail_list[0]
        }else if(this.curve_detail_list.length>1){
          this.curve_detail_data=this.curve_detail_list
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  #export_chart{
    width: 100%;
    height: 550px;
    zoom: 1.25;
  }
</style>



// WEBPACK FOOTER //
// src/components/cold/cold_storage_data.vue